var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDistributorCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2563 5.45625V16.6563M10.2563 5.45625C10.2563 3.19351 10.2563 2.06214 9.55331 1.35919C8.85036 0.65625 7.71899 0.65625 5.45625 0.65625C3.19351 0.65625 2.06214 0.65625 1.35919 1.35919C0.65625 2.06214 0.65625 3.19351 0.65625 5.45625V11.8563C0.65625 14.119 0.65625 15.2504 1.35919 15.9533C2.06214 16.6563 3.19351 16.6563 5.45625 16.6563H10.2563M10.2563 5.45625H13.4563C14.9647 5.45625 15.719 5.45625 16.1876 5.92488C16.6562 6.39351 16.6563 7.14776 16.6563 8.65625V13.4563C16.6563 14.9647 16.6562 15.719 16.1876 16.1876C15.719 16.6563 14.9647 16.6563 13.4563 16.6563H10.2563M4.25625 7.85625H3.45625M7.45625 7.85625H6.65625M4.25625 4.65625H3.45625M4.25625 11.0563H3.45625M7.45625 4.65625H6.65625M7.45625 11.0563H6.65625M13.8563 11.0563H13.0563M13.8563 7.85625H13.0563",
    stroke: "#155DFC",
    strokeWidth: 1.3125,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistributorCompany);
export default __webpack_public_path__ + "static/media/distributorCompany.516a1b05524dbec9352d28197e5ee8d8.svg";
export { ForwardRef as ReactComponent };